const HTML_CHARS: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(input: string): string {
  return input.replace(/[&<>"']/g, (ch) => HTML_CHARS[ch] ?? ch);
}

export function stripHtml(input: string): string {
  return input.replace(/<[^>]*>/g, "").replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "");
}

export function sanitizeDisplayName(raw: string, min = 3, max = 24): string | null {
  const cleaned = stripHtml(raw).replace(/\s+/g, " ").trim();
  if (cleaned.length < min || cleaned.length > max) return null;
  if (!/^[\p{L}\p{N} .'_\-]+$/u.test(cleaned)) return null;
  return cleaned;
}

export function sanitizeUsername(raw: string): string | null {
  const cleaned = raw.trim().toLowerCase();
  if (!/^[a-z0-9_]{3,24}$/.test(cleaned)) return null;
  return cleaned;
}

export function sanitizeBio(raw: string, max = 280): string {
  return stripHtml(raw).trim().slice(0, max);
}

export function linkifyHttps(text: string): string {
  const escaped = escapeHtml(text);
  return escaped.replace(
    /https:\/\/[^\s<]+/g,
    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`,
  );
}

export function looksLikeMention(text: string, username: string, displayName: string): boolean {
  const lower = text.toLowerCase();
  const u = username.toLowerCase();
  const d = displayName.toLowerCase();
  if (new RegExp(`(^|\\s)@${u}\\b`).test(lower)) return true;
  if (d.length >= 3 && new RegExp(`(^|\\s)@?${escapeRegExp(d)}\\b`).test(lower)) return true;
  return false;
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
